import apiClient from '../appConfig/interceptor';
import { endpoints } from '../utils/constants';

const getUsersList=()=>apiClient.get(`${endpoints.pathPrefix}user`);
const UpdateUser=(data: any)=>apiClient.put(`${endpoints.pathPrefix}user`, data);
const DeleteUser=(userName: string)=>apiClient.delete(`${endpoints.pathPrefix}user/${userName}`);

const userConfig = {
    getUsersList,
    UpdateUser,
    DeleteUser,
};
export default userConfig;